import React, { Fragment, useEffect, useState } from "react"
import {
  Row,
  Table,
  Button,
  Col,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { Link } from "react-router-dom"
import Spinners from "components/Common/Spinner"

import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getExpandedRowModel,
  flexRender,
  useTable,
  useRowSelect,
  ExpandedState,
} from "@tanstack/react-table"

import { rankItem } from "@tanstack/match-sorter-utils"
import JobListGlobalFilter from "./GlobalSearchFilter"
import StatusFilter from "./StatusFilter"
import DebouncedInput from "./DebouncedInput "
import controlEscolarMachine from "store/controlescolar/machine"

// Column Filter
const Filter = ({ column }) => {
  const columnFilterValue = column.getFilterValue()

  return (
    <>
      <DebouncedInput
        type="text"
        value={columnFilterValue ?? ""}
        onChange={value => column.setFilterValue(value)}
        placeholder="Search..."
        className="w-36 border shadow rounded"
        list={column.id + "list"}
      />
      <div className="h-1" />
    </>
  )
}

const TableContainerCargos = ({
  columns,
  data,
  tableClass,
  theadClass,
  divClassName,
  isBordered,
  isPagination,
  isGlobalFilter,
  paginationWrapper,
  SearchPlaceholder,
  pagination,
  buttonClass,
  buttonName,
  isAddButton,
  isCustomPageSize,
  handleUserClick,
  isJobListGlobalFilter,
  statusOptions,
  statusFilterfn,
  selectedValue,
  CustomPageSize,
  handleRowsSelectedFn,
  onClickDeleteDescuentoFn,
  onClickRefreshButtonFn,
  onClickAplicaDescuentoButtonFn,
  onClickOpengastosFn,
  onClickContribuyentesFn,
  onClickSolicitaLinkPagoFn,
  isLoading,
}) => {
  //
  const [columnFilters, setColumnFilters] = useState([])
  const [globalFilter, setGlobalFilter] = useState("")
  const [statusFilter, setStatusFilter] = useState("1,4")
  const [options, setOptions] = useState(statusOptions)
  const [expanded, setExpanded] = useState({})

  const [rowSelection, setRowSelection] = useState({})
  // Define el reducer para manejar las acciones de selección
  const rowSelectionReducer = (state, action) => {
    switch (action.type) {
      case "toggle_selection":
        return { ...state, [action.rowId]: action.checked }
      case "clear_selection":
        return {}
      default:
        return state
    }
  }

  const cargoVencido = fechaExpiracion => {
    const fechaHoy = new Date() // Obtiene la fecha actual
    const fechaExp = new Date(fechaExpiracion) // Convierte la fecha de expiración a un objeto Date

    // Ajuste para comparar solo la fecha (sin la hora)
    fechaHoy.setHours(0, 0, 0, 0)
    fechaExp.setHours(0, 0, 0, 0)

    if (fechaExp < fechaHoy) {
      return true
    } else {
      return false
    }
  }

  const filterObjectsByCondition = (objCondition, objArray) => {
    return Object.keys(objCondition) // Obtener las claves del objeto (como strings)
      .filter(key => objCondition[key]) // Filtrar las claves con valor `true`
      .map(key => objArray[parseInt(key)]?.original || false) // Mapear las claves a los objetos del arreglo
      .filter(item => item !== undefined) // Asegurar que los valores sean válidos
  }

  const fuzzyFilter = (row, columnId, value, addMeta) => {
    const itemRank = rankItem(row.getValue(columnId), value)
    addMeta({
      itemRank,
    })
    return itemRank.passed
  }

  const table = useReactTable({
    columns,
    data,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      columnFilters,
      globalFilter,
      rowSelection,
      expanded,
    },
    meta: {
      customToggleSelected: (row, value, opts) => {
        // Obtén el estado actual de la fila
        const isSelected = row.getIsSelected()

        // Condición personalizada: evitar selección o deselección de filas críticas
        if (cargoVencido(row.original.Fecha_Expiracion)) {
          console.warn(
            `La fila crítica ${row.id} no puede ser seleccionada ni deseleccionada.`
          )
          return
        }

        // Lógica para manejar selección/deselección
        table.setRowSelection(oldSelection => {
          value = typeof value !== "undefined" ? value : !isSelected

          if (row.getCanSelect() && isSelected === value) {
            return oldSelection // No cambia si no hay modificaciones
          }

          // Clona el estado actual
          const newSelection = { ...oldSelection }

          if (value) {
            // Selecciona la fila
            newSelection[row.id] = true
          } else {
            // Deselecciona la fila
            delete newSelection[row.id]
          }

          const selectedRows = filterObjectsByCondition(
            newSelection,
            table.getRowModel().rows
          )
          handleRowsSelectedFn(selectedRows)

          return newSelection // Devuelve el nuevo estado de selección
        })

        // console.log(
        //   `toggleSelected ejecutado para fila: ${row.id}, Valor: ${value}`
        // )
      },
    },
    enableRowSelection: true, //enable row selection for all rows
    // enableRowSelection: row => row.original.age > 18, // or enable row selection conditionally per row
    onRowSelectionChange: setRowSelection,
    onExpandedChange: setExpanded,
    //getSubRows: row => row.Lista_Descuentos,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getRowCanExpand: row => row.original.Lista_Descuentos.length > 0,
    debugTable: false,
  })

  const {
    getHeaderGroups,
    getRowModel,
    getCanPreviousPage,
    getCanNextPage,
    getPageOptions,
    setPageIndex,
    nextPage,
    previousPage,
    setPageSize,
    getState,
    getIsAllRowsSelected,
    getToggleAllRowsSelectedHandler,
  } = table

  const selectAllRows = () => {
    const allRowIds = getRowModel().rows.map(row => row.id) // Obtén los IDs de todas las filas visibles
    const selectedRowState = allRowIds.reduce((acc, id) => {
      acc[id] = true // Marca todas como seleccionadas
      return acc
    }, {})

    table.setRowSelection(selectedRowState) // Actualiza la selección en la tabla
  }

  useEffect(() => {
    selectAllRows()
    if (CustomPageSize > 0) table.setPageSize(Number(CustomPageSize))
  }, [])

  return (
    <Fragment>
      <Row className="mb-2">
        {isCustomPageSize && !CustomPageSize && (
          <Col sm={2}>
            <select
              className="form-select pageSize mb-2"
              value={table.getState().pagination.pageSize}
              onChange={e => {
                table.setPageSize(Number(e.target.value))
              }}
            >
              {[10, 20, 30, 40, 50].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
        )}
        {isGlobalFilter && (
          <DebouncedInput
            value={globalFilter ?? ""}
            onChange={value => setGlobalFilter(String(value))}
            className="form-control search-box me-2 mb-2 d-inline-block"
            placeholder={SearchPlaceholder}
          />
        )}
        {isJobListGlobalFilter && (
          <StatusFilter
            setStatusFilter={handleUserClick}
            options={options}
            selectedDefaultValue={selectedValue}
          />
        )}
        {isAddButton && (
          <Col className="d-flex justify-content-end">
            <div className="text-sm-end">
              <Button
                type="button"
                className={buttonClass}
                onClick={handleUserClick}
              >
                <i className="mdi mdi-plus me-1"></i> {buttonName}
              </Button>
              <Link
                to="#!"
                onClick={onClickRefreshButtonFn}
                className="btn btn-light me-1"
              >
                <i className="mdi mdi-refresh"></i>
              </Link>
              <UncontrolledDropdown className="dropdown d-inline-block me-1">
                <DropdownToggle
                  type="menu"
                  className="btn btn-info"
                  id="dropdownMenuButton1"
                >
                  <i className="mdi mdi-dots-vertical"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <li>
                    <DropdownItem href="#!">
                      <Link
                        to={`/contribuyentes`}
                        onClick={onClickContribuyentesFn}
                      >
                        Contribuyentes
                      </Link>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem href="#!" onClick={onClickOpengastosFn}>
                      <Link>Gastos</Link>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem href="#!" onClick={onClickSolicitaLinkPagoFn}>
                      <Link>Link Pago Personal</Link>
                    </DropdownItem>
                  </li>
                  {/* <li>
                    <DropdownItem href="#">Reporte Gastos</DropdownItem>
                  </li>
                  <li>
                    <DropdownItem href="#">Something else here</DropdownItem>
                  </li> */}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </Col>
        )}
      </Row>
      <div className={divClassName ? divClassName : "table-responsive"}>
        <Table hover className={tableClass} bordered={isBordered}>
          <thead className={theadClass}>
            {getHeaderGroups().map(headerGroup => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map(header => {
                  return (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      className={`${
                        header.column.columnDef.enableSorting
                          ? "sorting sorting_desc"
                          : ""
                      }`}
                    >
                      {header.isPlaceholder ? null : (
                        <React.Fragment>
                          <div
                            {...{
                              className: header.column.getCanSort()
                                ? "cursor-pointer select-none"
                                : "",
                              onClick: header.column.getToggleSortingHandler(),
                            }}
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {{
                              asc: "",
                              desc: "",
                            }[header.column.getIsSorted()] ?? null}
                          </div>
                          {header.column.getCanFilter() ? (
                            <div>
                              <Filter column={header.column} table={table} />
                            </div>
                          ) : null}
                        </React.Fragment>
                      )}
                    </th>
                  )
                })}
              </tr>
            ))}
          </thead>
          {!isLoading ? (
            <tbody>
              {getRowModel().rows.map(row => {
                return (
                  <>
                    <tr
                      key={row.id}
                      className=""
                      style={{
                        // textAlign: "center",
                        verticalAlign: "middle", // Asegura alineación vertical
                        padding: "10px",
                      }}
                    >
                      {row.getVisibleCells().map(cell => {
                        return (
                          <td key={cell.id}>
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </td>
                        )
                      })}
                    </tr>
                    {row.getIsExpanded() && (
                      <tr>
                        <td
                          colSpan={row.getAllCells().length}
                          style={{ paddingLeft: `2rem` }}
                        >
                          <Table
                            width={"100%"}
                            bordered={true}
                            className="table-condensed"
                          >
                            <thead>
                              <tr>
                                <th>Clave</th>
                                <th>Nombre</th>
                                <th>Cantidad</th>
                                <th>Porcentaje</th>
                                <th>Expira</th>
                                <th>Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              {row.original.Lista_Descuentos.map(descuento => {
                                return (
                                  <tr
                                    key={descuento.id_Relacion_Descuento_Cargo}
                                  >
                                    <td>{descuento.Clave_Descuento}</td>
                                    <td>{descuento.Clave_Nombre}</td>
                                    <td>
                                      {descuento.Cantidad.toLocaleString()}
                                    </td>
                                    <td>{descuento.Porcentaje}</td>
                                    <td>{descuento.Fecha_Expiracion}</td>
                                    <td>
                                      {" "}
                                      <ul className="list-unstyled hstack gap-1 mb-0">
                                        <li>
                                          <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-danger"
                                            onClick={() => {
                                              onClickDeleteDescuentoFn(
                                                descuento
                                              )
                                            }}
                                            id={`deletetooltip-${descuento.id_Relacion_Descuento_Cargo}`}
                                          >
                                            <i className="mdi mdi-delete-outline" />
                                            <UncontrolledTooltip
                                              placement="top"
                                              target={`deletetooltip-${descuento.id_Relacion_Descuento_Cargo}`}
                                            >
                                              Cancelar
                                            </UncontrolledTooltip>
                                          </Link>
                                        </li>
                                      </ul>
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    )}
                  </>
                )
              })}
            </tbody>
          ) : (
            <></>
          )}
        </Table>
      </div>
      {/* {console.log(table.getSelectedRowModel())} */}
      {isPagination && (
        <Row>
          <Col sm={12} md={5}>
            <div className="dataTables_info">
              {/* Showing {getState().pagination.pageSize} of {data.length} Results */}
              Showing{" "}
              {getState().pagination.pageSize <
              table.getFilteredRowModel().rows.length
                ? getState().pagination.pageSize
                : table.getFilteredRowModel().rows.length}{" "}
              of {table.getFilteredRowModel().rows.length} Results
            </div>
          </Col>
          <Col sm={12} md={7}>
            <div className={paginationWrapper}>
              <ul className={pagination}>
                <li
                  className={`paginate_button page-item previous ${
                    !getCanPreviousPage() ? "disabled" : ""
                  }`}
                >
                  <Link to="#" className="page-link" onClick={previousPage}>
                    <i className="mdi mdi-chevron-left"></i>
                  </Link>
                </li>

                {getPageOptions()
                  .filter(item => {
                    const currentPage = getState().pagination.pageIndex
                    const totalPages = getPageOptions().length

                    // Show first, last, current page, and pages around current page
                    return (
                      item === 0 ||
                      item === totalPages - 1 ||
                      (item >= currentPage - 1 && item <= currentPage + 1) ||
                      (item <= 3 && currentPage <= 3) ||
                      (item >= totalPages - 4 && currentPage >= totalPages - 4)
                    )
                  })
                  .map((item, key, array) => {
                    const isSeparatorBefore =
                      key > 0 && item - array[key - 1] > 1
                    const isSeparatorAfter =
                      key < array.length - 1 && array[key + 1] - item > 1

                    return (
                      <React.Fragment key={key}>
                        {isSeparatorBefore && (
                          <li className="page-item">...</li>
                        )}
                        <li
                          className={`paginate_button page-item ${
                            getState().pagination.pageIndex === item
                              ? "active"
                              : ""
                          }`}
                        >
                          <Link
                            to="#"
                            className="page-link"
                            onClick={() => setPageIndex(item)}
                          >
                            {item + 1}
                          </Link>
                        </li>
                        {isSeparatorAfter && <li className="page-item">...</li>}
                      </React.Fragment>
                    )
                  })}

                <li
                  className={`paginate_button page-item next ${
                    !getCanNextPage() ? "disabled" : ""
                  }`}
                >
                  <Link to="#" className="page-link" onClick={nextPage}>
                    <i className="mdi mdi-chevron-right"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      )}
      {isLoading ? <Spinners setLoading={() => {}} /> : <></>}
    </Fragment>
  )
}

export default TableContainerCargos
